import { ServiceDataFields } from './service-data-fields.enum';

export const carrierFieldSet = [
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.ChromosomalAbnormalityCarrier,
  ServiceDataFields.CarrierOfGeneticCondition,
  ServiceDataFields.HistoryOfCancer,
  ServiceDataFields.StemCellTherapy,
  ServiceDataFields.TransplantSurgery,
  ServiceDataFields.BloodTransfusion,
  ServiceDataFields.FamilyHistoryOfCysticFibrosis,
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.DocumentNumber,
];
